let ctx = null;
let unlocked = false;

function getContext() {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    return ctx;
}

function ensureResumed() {
    const audio = getContext();
    if (audio.state === "suspended") {
        return audio.resume();
    }
    return Promise.resolve();
}

function playTone(frequency, duration, type = "sine", gain = 0.3) {
    if (SoundManager._muted) return;
    ensureResumed().then(() => {
        const audio = getContext();
        const osc = audio.createOscillator();
        const vol = audio.createGain();

        osc.type = type;
        osc.frequency.value = frequency;
        vol.gain.value = gain;
        vol.gain.exponentialRampToValueAtTime(0.001, audio.currentTime + duration);

        osc.connect(vol);
        vol.connect(audio.destination);
        osc.start(audio.currentTime);
        osc.stop(audio.currentTime + duration);
    });
}

function unlockAudio() {
    if (unlocked) return;
    unlocked = true;
    const audio = getContext();
    if (audio.state === "suspended") {
        audio.resume();
    }
    const silent = audio.createOscillator();
    const silentGain = audio.createGain();
    silentGain.gain.value = 0;
    silent.connect(silentGain);
    silentGain.connect(audio.destination);
    silent.start();
    silent.stop(audio.currentTime + 0.001);
}

document.addEventListener("touchstart", unlockAudio, { once: true, capture: true });
document.addEventListener("touchend", unlockAudio, { once: true, capture: true });
document.addEventListener("click", unlockAudio, { once: true, capture: true });

export default class SoundManager {
    static _muted = localStorage.getItem("geonerd.muted") === "true";

    static get muted() { return this._muted; }

    static toggle() {
        this._muted = !this._muted;
        localStorage.setItem("geonerd.muted", this._muted);
        return this._muted;
    }
    static correct() {
        playTone(523, 0.1);
        setTimeout(() => playTone(659, 0.1), 80);
        setTimeout(() => playTone(784, 0.15), 160);
    }

    static wrong() {
        playTone(200, 0.15, "square", 0.2);
        setTimeout(() => playTone(150, 0.2, "square", 0.2), 120);
    }

    static victory() {
        const notes = [523, 659, 784, 659, 784, 1047];
        const durations = [0.12, 0.12, 0.12, 0.12, 0.12, 0.3];
        let delay = 0;
        notes.forEach((freq, i) => {
            setTimeout(() => playTone(freq, durations[i], "sine", 0.25), delay);
            delay += durations[i] * 700;
        });
    }

    static gameOver() {
        const notes = [392, 370, 349, 330, 294];
        const durations = [0.2, 0.2, 0.2, 0.2, 0.5];
        let delay = 0;
        notes.forEach((freq, i) => {
            setTimeout(() => playTone(freq, durations[i], "triangle", 0.25), delay);
            delay += durations[i] * 800;
        });
    }
}
